/* global propel */
import { Loader } from '@googlemaps/js-api-loader';

let loaded = false;

const loadGoogleMaps = () => {
	if (loaded) {
		return;
	}

	loaded = true;

	document.removeEventListener('scroll', loadGoogleMaps);
	document.removeEventListener('mousemove', loadGoogleMaps);
	document.removeEventListener('touchstart', loadGoogleMaps);

	if (propel.googleApiKey) {
		const loader = new Loader({
			apiKey: propel.googleApiKey,
			version: 'weekly',
		});

		loader.importLibrary('maps').then(() => {
			const loadedEvent = new Event('google-maps-loaded');
			window.dispatchEvent(loadedEvent);
		});
	}
};

document.addEventListener('scroll', loadGoogleMaps);
document.addEventListener('mousemove', loadGoogleMaps);
document.addEventListener('touchstart', loadGoogleMaps);

const blocks = document.querySelectorAll(
	'.block-filter-locations, .block-hero-map'
);

if (blocks.length > 0 && window.innerWidth >= 768) {
	window.addEventListener('load', loadGoogleMaps);
}
